/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowsInLineVertical(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M224,128a8.00039,8.00039,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8.00039,8.00039,0,0,1,224,128ZM122.34277,101.65723a8.00181,8.00181,0,0,0,11.31446,0l32-32A8.00066,8.00066,0,0,0,160,56H136V16a8,8,0,0,0-16,0V56H96a8.00066,8.00066,0,0,0-5.65723,13.65723Zm11.31446,52.68554a8.003,8.003,0,0,0-11.31446,0l-32,32A8.00066,8.00066,0,0,0,96,200h24v40a8,8,0,0,0,16,0V200h24a8.00066,8.00066,0,0,0,5.65723-13.65723Z" />
    </Svg>
  );
}

export default ArrowsInLineVertical;
